import { useEffect, useState } from 'react';
import { eliDetalleHorario, obtenerDetalleHorario } from '../../services/HorarioTurno/TurnoService';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import NuevoDetalleHorario from './NuevoDetalleHorario';
import { useContextAdminHora } from './ContextAdminHorario';
import EditaDetalle from './EditaDetalle'

const EditaHorario = ({ datosHorario, ocultaDialogEdita }) => {
    const { horarioId, nombre, sigla } = datosHorario;

    const [cargaDetHorario, setCargaDetHorario] = useState(true);
    const [lstDetHorario, setLstDetHorario] = useState([]);

    const [mostrarNuevo, setMostrarNuevo] = useState(false);
    const [mostrarEdita, setMostarEdita] = useState(false)
    const [refresca, setRefresca] = useState(false)
    const [horarioDetalle, setHorarioDetalle] = useState()

    const showToast = useContextAdminHora();

    useEffect(() => {
        const cargaDetalle = async () => {
            try {
                setCargaDetHorario(true);
                const response = await obtenerDetalleHorario(horarioId);
                //console.log('WW01', response)
                setLstDetHorario(response);
            } catch (error) {
                console.error(error.message);
            } finally {
                setCargaDetHorario(false);
            }
        };
        cargaDetalle();
    }, [refresca]);

    const formatoHora = (objTime) => {
        if (!objTime) return '';
        const { hour, minute } = objTime;
        const hora = String(hour).padStart(2, '0');
        const minuto = String(minute).padStart(2, '0');
        return `${hora}:${minuto}`;
    };

    const horaInicioTemplate = (filaData) => {
        return formatoHora(filaData.horaInicio);
    };
    const horaFinalTemplate = (filaData) => {
        return formatoHora(filaData.horaFin);
    };

    const eliminaDetalle = async (horarioDetalleId) => {
        try {
            console.log(horarioDetalleId)
            const response = await eliDetalleHorario(horarioDetalleId)
            showToast ('success', 'Success', 'Proceso ejecutado con exito')
            setRefresca( prevValue => !prevValue )
        } catch (error) {
            console.error('Error: ', error.message)
            showToast ('error', 'Error', 'Se ha producido un Error y no se ha borrado')
        }
    }

    const editaDetalleClick = async (itemDetalle) => {
        //console.log('WWW01:', itemDetalle)
        setHorarioDetalle(itemDetalle)
        setMostarEdita(true)
    }

    const actionButtonBodyEdit = (filaData) => {
        return (
            <div className="flex justify-center gap-2">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-info" tooltip="Editar" onClick={()=> editaDetalleClick(filaData) } />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" tooltip="Eliminar" onClick={()=> eliminaDetalle(filaData.horarioDetalleId)} />
            </div>
        );
    };

    const ocultaDialogNuevo = () => {
        setMostrarNuevo(false);
        // podemos asumir que habian cambios
        setRefresca( prevValue => !prevValue )
    };

    const ocultaDialogEditDetalle = () => {
        setMostarEdita(false)
        // podemos asumir que habian cambios
        setRefresca( prevValue => !prevValue )
    }

    const onNuevo = () => {
        setMostrarNuevo(true);
    }

    return (
        <div className="card">
            <Dialog visible={mostrarNuevo} style={{ width: '45vw' }} onHide={ocultaDialogNuevo} modal draggable={false}>
                <NuevoDetalleHorario horarioId={horarioId} ocultaDialogNuevo={ocultaDialogNuevo} />
            </Dialog>
            <Dialog visible={mostrarEdita} style={{ width: '45vw' }} onHide={ocultaDialogEditDetalle} modal draggable={false}>
                <EditaDetalle horarioDetalle={horarioDetalle} ocultaDialogEditDetalle={ocultaDialogEditDetalle} />
            </Dialog>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-8">
                    <div>
                        <h5>Editar Horario</h5>
                        <p>
                            <strong>Sigla:</strong> {sigla}{' '}
                        </p>
                        <p>
                            <strong>Nombre:</strong> {nombre}
                        </p>
                    </div>
                </div>
                <div className="field col-12 md:col-4">
                    <Button label="Nuevo Detalle" onClick={onNuevo} />
                </div>
            </div>

            <DataTable loading={cargaDetHorario} loadingIcon="pi pi-spin pi-spinner" value={lstDetHorario} tableStyle={{ width: '100%' }}>
                <Column header="Hora Inicio" body={horaInicioTemplate} style={{ width: '30%' }} />
                <Column header="Hora Final" body={horaFinalTemplate} style={{ width: '30%' }} />
                <Column header="Acciones" style={{ width: '40%' }} body={actionButtonBodyEdit} />
            </DataTable>
            <br />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-12">
                    <Button label="Cancelar" onClick={ocultaDialogEdita} disabled={cargaDetHorario} />
                </div>
            </div>
        </div>
    );
};
export default EditaHorario;
